"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HABILLAGES = exports.CIBLES_CONSOLE = exports.CIBLES = void 0;
exports.habillage = habillage;
/**
 * Cibles tactiles. La zone touchable d'un contrôle n'est pas sa taille visible :
 * une puce ou une icône peut être petite, sa zone de contact ne descend jamais
 * sous le minimum.
 */
exports.CIBLES = {
    minimum: 48,
    principale: 56,
    ecart: 8,
};
/**
 * Cibles de la console — l'exception, et la seule.
 *
 * Les 48 px du système sont justifiés par une condition d'usage précise : « le
 * produit s'utilise d'une main, dans un véhicule en mouvement, sur des écrans
 * de 5 pouces ». La console ne remplit aucune de ces conditions — elle s'opère
 * au clavier et au pointeur, sur un poste fixe, et sa raison d'être est de
 * balayer des tableaux denses. Lui imposer la cible du pouce lui coûterait la
 * densité sans rien protéger.
 *
 * L'exception est bornée et nommée plutôt que laissée implicite : elle vit ici,
 * pas dans une valeur en dur au fond d'une feuille de styles. L'écart entre
 * cibles, lui, ne bouge pas — 8 px sur toutes les surfaces.
 */
exports.CIBLES_CONSOLE = {
    minimum: 32,
    principale: 36,
    ecart: 8,
};
const MESURES_MOBILE = {
    pas: 8,
    rayonPetit: 6,
    rayon: 12,
    rayonMoyen: 16,
    rayonLarge: 20,
    texteBase: 16,
};
const MESURES_CONSOLE = {
    pas: 8,
    rayonPetit: 3,
    rayon: 5,
    rayonMoyen: 6,
    rayonLarge: 8,
    texteBase: 15,
};
const OMBRE_CLAIRE = '0 1px 2px rgba(16,31,28,.06), 0 10px 30px -22px rgba(16,31,28,.4)';
const OMBRE_SOMBRE = '0 1px 2px rgba(0,0,0,.5), 0 12px 34px -24px rgba(0,0,0,.9)';
/**
 * Passager — fond clair, consulté au soleil, debout, quelques secondes.
 */
const PASSAGER = {
    couleurs: {
        fond: '#FFFFFF',
        surface: '#FFFFFF',
        surfaceDouce: '#E4F1EE',
        texte: '#0D1F1C',
        texteSecondaire: '#5A706A',
        texteTertiaire: '#5C706C',
        accent: '#046A63',
        surAccent: '#FFFFFF',
        accentDouce: '#E4F1EE',
        accentSombre: '#03514C',
        alerte: '#A62B1F',
        alerteDouce: '#F7DEDA',
        attention: '#8F5400',
        attentionDouce: '#F7E9CE',
        ligne: '#D5E0DC',
        ligneForte: '#BCCCC7',
    },
    mesures: MESURES_MOBILE,
    ombre: OMBRE_CLAIRE,
};
/**
 * Chauffeur — fond sombre, support de tableau de bord, souvent de nuit.
 */
const CHAUFFEUR = {
    couleurs: {
        fond: '#0B1A17',
        surface: '#13251F',
        surfaceDouce: '#1B322B',
        texte: '#E9F2EE',
        texteSecondaire: '#A2B8B2',
        texteTertiaire: '#829994',
        accent: '#3FBFAE',
        surAccent: '#04211D',
        accentDouce: '#102F2A',
        accentSombre: '#7FDACB',
        alerte: '#E8796B',
        alerteDouce: '#38201C',
        attention: '#E0A43C',
        attentionDouce: '#33280F',
        ligne: '#1E3733',
        ligneForte: '#2B4D45',
    },
    mesures: MESURES_MOBILE,
    ombre: OMBRE_SOMBRE,
};
/**
 * Console — poste de travail, dense, tableaux à balayer.
 */
const CONSOLE = {
    couleurs: {
        fond: '#EFF3F1',
        surface: '#FFFFFF',
        surfaceDouce: '#F6F9F8',
        texte: '#101F1C',
        texteSecondaire: '#465C57',
        texteTertiaire: '#5F726E',
        accent: '#046A63',
        surAccent: '#FFFFFF',
        accentDouce: '#DCEEEA',
        accentSombre: '#03514C',
        alerte: '#A62B1F',
        alerteDouce: '#F7DFDB',
        attention: '#8F5400',
        attentionDouce: '#F8EAD0',
        ligne: '#DCE5E2',
        ligneForte: '#C1D0CB',
    },
    mesures: MESURES_CONSOLE,
    ombre: OMBRE_CLAIRE,
};
exports.HABILLAGES = {
    passager: PASSAGER,
    chauffeur: CHAUFFEUR,
    console: CONSOLE,
};
function habillage(surface) {
    return exports.HABILLAGES[surface];
}
//# sourceMappingURL=jetons.js.map